import { useSelector } from 'react-redux';
import { FileUploadOptions } from '@wix/da-shared-react/pkg/utils/hooks/useFileUpload';
import { MIME_CONFIG } from '@wix/da-shared-react/pkg/utils/mime';
import { getActiveSection, getSelectedFolder } from '../selectors/studio';
import { StudioSection } from '../types/store';
import { UploadType } from '@wix/da-shared-react/pkg/redux/uploads/types';
import { STUDIO_UPLOADS_NAMESPACE, SAVED_SUBMISSIONS_FOLDER_NAME } from '../../constants';

export function useStudioUploadOptions(options?: Partial<FileUploadOptions>): FileUploadOptions {
  const selectedFolder = useSelector(getSelectedFolder);
  const isStashSection = useSelector(getActiveSection) === StudioSection.STASH;
  let folderName;
  let folderId;

  if (isStashSection) {
    folderId = selectedFolder?.folderId;
  } else {
    folderName = SAVED_SUBMISSIONS_FOLDER_NAME;
  }

  return {
    id: STUDIO_UPLOADS_NAMESPACE,
    uploadType: UploadType.DEVIATION_NEW,
    uploadParams: {
      folderId,
      folderName,
      useDefaults: true,
    },
    acceptedMimeTypes: MIME_CONFIG.forDeviationSubmit,
    allowMultiple: true,
    ...options,
  };
}
